export const harcodedTextFlagData = {};
